module.exports = __webpack_public_path__ + "img/planta-desktop@2x.7ca0cc75.png";